module.exports = __webpack_public_path__ + "img/youtube_icon.420bd50f.svg";